import router from '@/router'

export default {
  name: 'ContactPage',
  components: {
  },
  data () {
    return {
      valid_form: true,
      form: {},
      form_completed: false,
      loading: false,
      rules: {
        email: [
          (v) => !!v || "Un email est requis",
          (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Format d'email non valide"
        ],
        name: [
          (v) => !!v || "Merci d'entrer vos informations",
          (v) => v && v.length <= 100 || "Texte trop long - limite de 100 caractères"
        ],
        text_long: [
          (v) => !!v || "",
          (v) => v && v.length <= 5000 || "Texte trop long - limite de 5000 caractères"
        ],
        phone: [
          (v) => !!v || "Un numéro de téléphone est requis",
          (v) => v && (v.length <= 18 && v.length > 8) || "Format de numéro de téléphone non valide"
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    redirectTo(url) {
      if(url) {
        this.$router.push(url)
      }
    },
    validate_form () {
      if (this.$refs.form.validate()) {
        this.form_completed = true
      }
    },
    sendMail() {
      // alert('init ==>' + JSON.stringify(this.generateEmailContent()))
      var emailForm = {
        SecureToken : "7fe33d25-4ae4-4f5d-9d44-ea4291b2816e",
        To : 'drsaadryan@gmail.com',
        From : "zemahmoud@hotmail.fr",
        Subject : "Contact site web - " + this.form.name,
        Body : this.generateEmailContent()
      }
      /*
      7fe33d25-4ae4-4f5d-9d44-ea4291b2816e
      SecureToken : "7fe33d25-4ae4-4f5d-9d44-ea4291b2816e",
      To : 'asterixm117@gmail.com',
      From : "asterixm117@gmail.com",
      Subject : "Contact site web - " + this.form.name,
      Body : this.generateEmailContent()
      */
      Email.send(emailForm).then(
        message => {
          if (message == 'OK') {
            alert('Message envoyé avec succès !')
          }
          else {
            alert("Le message n'a pas pû être envoyé, nous sommes désolés pour la gêne occasionnée. En cas d'echec répété, merci de bien vouloir contacter le cabinet directement par téléphone au 01 56 53 58 58")
          }
        }
      );
    },
    generateEmailContent() {
      var emailContent = "<br>Bonjour Dr Ryan Saad,<br>"
      emailContent += "<br>"
      emailContent += "Vous avez reçu un message depuis le formulaire sur votre site web !<br>"
      emailContent += "<br>"
      emailContent += "<u>Informations du client </u>: <br>"
      emailContent += "<b>Nom </b>: " + this.form.name + "<br>"
      emailContent += "<b>Adresse mail </b>: " + this.form.email + "<br>"
      emailContent += "<b>Numéro de téléphone </b>: " + this.form.phone_number + "<br>"
      emailContent += "<br>"
      emailContent += "<u>Message envoyé par le client </u>:<br>"
      emailContent += '"<b> ' + this.form.message.replace(/(?:\r\n|\r|\n)/g, '<br>') + ' </b>"<br>'
      emailContent += "<br>"
      emailContent += "<br>"
      emailContent += "Bonne journée Docteur Saad !"

      return emailContent
    }
  },
  computed: {
  },
  watch: {
    form_completed: async function(completed) {
      if (completed) {
          this.sendMail()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/pages/contact/contact.component.js